import { useLoggingStore } from 'src/stores/logging';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, tap, } from 'rxjs/operators';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
import { axiosCallerPlugin } from 'src/plugins/axios/componentAxiosCallerPlugin';
import { ChatMiscDataPlugin } from 'src/features/messaging/chat/components/methods/misc';
import customPrompt from 'src/components/alert/customPrompt.vue';
/**
 * Plugin for user reporting host bypass
 */
const ReportBypassPlugin = (reportCallback = () => { }) => {
    const loggingStore = useLoggingStore();
    const $q = useQuasar();
    const { axiosCall } = axiosCallerPlugin();
    const { isChatUser, convo } = ChatMiscDataPlugin();
    const { subject: report$ } = rxInitSubjectCallback();
    function report(data) {
        $q.dialog({
            component: customPrompt,
            componentProps: {
                text: 'Report host?'
            }
        }).onOk(() => {
            report$.next(data);
        });
    }
    useObservable(report$.pipe(filter(() => isChatUser.value !== ''), switchMap((data) => {
        return of('').pipe(switchMap(() => {
            return axiosCall({
                type: 'create',
                state: 'card',
                loading: true,
                url: `user_dashboard/${convo.value.id}/report_host_for_bypass`,
                data: {
                    ...(data || {})
                },
                alert: false
            });
        }), catchError((err) => {
            void loggingStore.errorHandler(err);
            return of({
                success: false,
                data: null
            });
        }), map((v) => v), filter(({ success }) => success), tap(() => {
            reportCallback();
        }));
    })));
    return {
        report
    };
};
export { ReportBypassPlugin };
